<div class="form-group">
    <label class="input-label">{{"Date Format" | translate}}:
            <i style="cursor: help" class="fal fa-lightbulb"
            [tooltip]="'Use this field to override format of the shown date and time (date&time standards are different across the world)' | translate"
            aria-hidden="true"></i>
    </label>
    <input type="text"
           name="fieldOptions.format"
           value="{{fieldOptions.format}}"
           [(ngModel)]="fieldOptions.format"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>